import AdminCrudPage from "./AdminCrudPage";

export default function AdminBlogs() {
  return (
    <AdminCrudPage
      title="Blogs"
      endpoint="blogs"
      initial={{ title: "", excerpt: "", content: "", cover_image: "", author: "Tara Autohub Team", category: "Industry News", tags: [], published: true }}
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "author", label: "Author" },
        { key: "published", label: "Published", render: (it) => it.published ? "Yes" : "Draft" },
      ]}
      fields={[
        { name: "title", label: "Title" },
        { name: "excerpt", label: "Excerpt", type: "textarea", rows: 2 },
        { name: "content", label: "Content (HTML supported)", type: "richtext" },
        { name: "cover_image", label: "Cover Image", type: "image" },
        { name: "author", label: "Author" },
        { name: "category", label: "Category" },
        { name: "tags", label: "Tags", type: "tags" },
        { name: "published", label: "Published", type: "boolean" },
      ]}
    />
  );
}
